<template>
  <div class="login">
    <h1>This is an login page</h1>

    <router-link to="/" class="btn btn-primary">Entrar</router-link>
    <h1 @click="goTo('/')">
        Autenticado, vá pra home.
    </h1>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { mapFilters } from '@/helpers/filters'
import axios from 'axios'

export default {
    computed: {
        username () {
            // We will see what `params` is shortly
            // return this.$route.params.username
        }
    },
    methods: {
        goBack () {
            window.history.length > 1? this.$router.go(-1) : this.$router.push('/')
        },
        goTo (target) {
            this.$router.push(target)
        },
    }
}

</script>

<style>

</style>
